import { useMemo } from 'react'
import Table, { Column } from 'common/Table'
import DateObject from 'react-date-object'

interface Props {
  logs: any[]
}
const LogsList = ({ logs }: Props) => {
  const getTableCellStyle = (level: string | undefined) => {
    let background = '#FFFFFF'
    let color = 'black'

    switch (level) {
      case 'warn':
        background = '#8F7400'
        color = '#FFFFFF'
        break

      case 'error':
        background = '#730000'
        color = '#FFFFFF'
        break

      default:
        break
    }

    return { background, color }
  }

  const columns = useMemo(() => {
    const keys = new Set()
    logs?.forEach((obj) => {
      Object.keys(obj).forEach((key) => keys.add(key))
    })

    return (Array.from(keys) as string[]).map<Column<any>>((key) => {
      const style = ({ level }: any) => getTableCellStyle(level)

      switch (key) {
        case 'ts':
          return {
            id: 'ts',
            label: 'Timestamp',
            content: (item) =>
              item.ts ? new DateObject(item.ts * 1000).format('YYYY/MM/DD HH:mm:ss') : '_',
            style,
            width: 200,
          }

        default:
          return {
            id: key,
            label: key,
            content: (item) =>
              item[key] && typeof item[key] === 'object' ? JSON.stringify(item[key]) : item[key],
            style,
            width: 150,
          }
      }
    })
  }, [logs])

  return <Table columns={columns} data={logs} />
}

export default LogsList
